'use client'

import { memo } from 'react'
import { WarningIcon, ArrowClockwiseIcon } from '@phosphor-icons/react'

export const EntriesErrorState = memo(function EntriesErrorState({
  onRetry,
}: {
  onRetry: () => void
}) {
  return (
    <div className="py-12 text-center">
      <WarningIcon className="text-muted-foreground/50 mx-auto h-10 w-10" />
      <p className="text-foreground mt-3 text-sm font-medium">
        Failed to load entries
      </p>
      <p className="text-muted-foreground mt-1 text-xs">
        Something went wrong. Please try again.
      </p>
      <button
        type="button"
        onClick={onRetry}
        className="text-foreground hover:bg-muted focus-visible:ring-ring mt-4 inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors focus-visible:ring-2 focus-visible:outline-none"
      >
        <ArrowClockwiseIcon className="h-4 w-4" aria-hidden="true" />
        Try again
      </button>
    </div>
  )
})
